import React from 'react';
import 'components/row-wrapper/row-wrapper.scss';

export interface RowWrapperProps {
    headerVisible: boolean;
    title: string;
    /** Active contracts the user has, shown right-aligned on the same row as the month name. Undefined
     *  while it's still loading — left out rather than shown as a misleading 0. */
    contractsCount?: number;
}

const RowWrapper: React.FC<RowWrapperProps> = (props) => {
    return (
        <>
            {props.headerVisible && (
                <tr>
                    <td colSpan={2} className={'follow-up-month-title'}>
                        <div className={'follow-up-month-title-content'}>
                            <span className={'follow-up-month-title-text'}>{props.title}</span>
                            {props.contractsCount !== undefined && (
                                <span
                                    className={'follow-up-month-contracts-count'}
                                >{`${props.contractsCount} Contratos activos`}</span>
                            )}
                        </div>
                    </td>
                </tr>
            )}
            <tr className={'atp-card'}>{props.children}</tr>
        </>
    );
};

export default RowWrapper;
